import React from 'react';
import Opportunity from "../../models/Opportunity";
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";
import Component from '../../components/Component'
import RequestButton from "../../components/RequestButton";

export default class OppTeamStatusModalStep extends Component {

    static events() {
        return {
            "Opportunities@updated": (component, opportunity) => {
                // console.log('Opportunities@updated', opportunity)
                if (component.state.opportunity?.id === opportunity?.id && !component.state.isLoading){
                    component.setState({opportunity})
                }
            }
        }
    };

    constructor(props) {
        super(props);

        this.modalRef = React.createRef();
        this.state = {
            isLoading: true,
            opportunity: props.opportunity
        }
    }

    async componentDidMount() {
        await super.componentDidMount();
        this.loadOpportunity();
    }

    async loadOpportunity() {
        let opportunity = await Opportunity.fetchForTalent(
            this.props.opportunity.id,
            true
        );

        if (!opportunity) {
            return this.handleErrorResponse(
                Opportunity.FetchRequest, {
                    500: 'error_show_project',
                    404: 'error_opportunity_not_found',
                }
            );
        }

        await this.promisedState({opportunity, isLoading: false});
    }

    async acceptForTeam() {

        await this.promisedState({isDisabled: true});

        let opportunity = await this.state.opportunity.update({
            accepted_for_team_at: new Date()
        });

        if (!opportunity) {
            return this.handleErrorResponse(
                Opportunity.SyncRequest
            );
        }

        await this.promisedState({opportunity, isDisabled: false});

        return this.props.onClose(
            () => TB.sysAlert('talent.opportunity_accepted_for_team'), true
        )
    }

    async sendReminder(member) {
        await this.promisedState({isDisabled: true})

        await TB.wait(250);

        await this.state.opportunity.remindMember(member);

        await TB.wait(250);

        await this.promisedState({isDisabled: false})
    }

    renderTeamStatus() {
        let {
            opportunity,
            isDisabled
        } = this.state;
        let members = opportunity.teamMembers();


        let auth = this.context?.auth;
        return (
            <table className="table table-bordered team-status-modal-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                {members.map(member => (
                    <tr key={`member-${member.id}`}>
                        <td className="team-member-name">
                            <p>
                                {member.firstNamePlusInitial()} {member.id === auth.id && (
                                    <span className="text-danger ml-1">
                                        (You)
                                    </span>
                            )}
                            </p>
                        </td>
                        <td className="team-member-role">
                            <p>
                                {member.is_admin ? 'Admin' : 'Member'}
                            </p>
                        </td>
                        <td className="team-member-status">
                            {(member.accepted_at || member.rejected_at) ? (
                                <p className={member.accepted_at ? 'text-success' : 'text-danger'}>
                                    {member.accepted_at ? 'Pursued' : 'Passed'}
                                </p>
                            ) : (
                                <RequestButton
                                    onRequest={() => this.sendReminder(member)}
                                    disabled={!member.can_remind_to_accept || member.reminded_to_accept_at}
                                    className={TB.mapClass("btn btn-primary", {
                                        'no-click': isDisabled
                                    })}>
                                    {(!member.can_remind_to_accept || member.reminded_to_accept_at) ?
                                        `Reminded: ${TB.moment(member.reminded_to_accept_at).format('ll')}`
                                        : 'Send Reminder'
                                    }
                                </RequestButton>
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        )
    }

    render() {
        let {
            opportunity,
            isLoading,
            isDisabled,
            error
        } = this.state;

        return (
            <div className="opportunity-team-status-modal">

                <div className="team-status-modal-header">

                    <h3>Team Status for {opportunity.team.name} <span>(Project: {opportunity.project.name})</span></h3>

                </div>


                <div className="team-status-modal-container">

                    {isLoading && <LoadingBanner message="Loading"/>}

                    {TB.isObject(error) && (
                        <ErrorBanner {...error} onRetry={this.loadOpportunity.bind(this)}/>
                    )}

                    {!isLoading && !error && this.renderTeamStatus()}

                    {!isLoading && !error && (
                        <div className={TB.mapClass("team-status-modal-footer", {
                            'flex-row': opportunity.canAdmin()
                        })}>
                            <div className="modal-footer-title">
                                Status:  PENDING DECISION TO PURSUE
                            </div>
                            {opportunity.canAdmin() ? (
                                <button onClick={() => this.acceptForTeam()}
                                        disabled={isDisabled || !opportunity.canAcceptForTeam()}
                                        className="btn btn-primary">
                                    Pursue Opportunity for Team
                                </button>
                            ) : (
                                <p className="text-muted" dangerouslySetInnerHTML={{__html: TB.trans('talent.team_status_modal_member_info')}}/>
                            )}
                        </div>
                    )}
                </div>

            </div>
        );
    }
}
